import React from 'react';
import Box from '@material-ui/core/Box';
import { useQuery } from 'react-apollo';
import { GET_STUDENT_ROOMS } from 'graphql/student/chat';
import Spin from 'components/common/Spin';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AvatarGroup from '@material-ui/lab/AvatarGroup';
import Avatar from '@material-ui/core/Avatar';
import { getInitials } from 'utils';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import IconButton from '@material-ui/core/IconButton';
import Room from '../../student/chat/components/Room';

const useStyles = makeStyles((theme) => ({
  header: {
    boxShadow: '0px 5px 47px rgba(44, 9, 12, 0.05)',
    zIndex: 1,
    position: 'relative',
    paddingBottom: 0,
  },
  tabContent: {
    'flex': 1,
    '& > div': {
      height: 'calc(100vh - 280px)',
      [theme.breakpoints.down('xs')]: {
        height: 'calc(100vh - 225px)',
      },
    },
  },
  backIcon: {
    display: 'none',
    marginRight: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      display: 'block',
    },
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
}

function a11yProps(index) {
  return {
    'id': `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const StudentChatRooms = ({ match, history }) => {
  const classes = useStyles();
  const { studentId } = match.params;
  const [tab, setTab] = React.useState(0);
  const user = useSelector((s) => s.user.user);
  const { data, loading } = useQuery(GET_STUDENT_ROOMS, {
    fetchPolicy: 'network-only',
    variables: { user_id: studentId },
  });

  if (loading) return <Spin spinning linear />;
  const { users } = data;
  const student = users[0];
  // console.log(student)
  const { chat_rooms: rooms } = student;

  const handleTabChange = (event, newValue) => {
    setTab(newValue);
  };

  const coachRoom = rooms.find((r) => r.room_name === 'parents_coaches');
  const adminRoom = rooms.find((r) => r.room_name === 'parents_admin');
  const faRoom = rooms.find((r) => r.room_name === 'parents_fa');

  const isSolo = student.product_type === 'solo';
  const isCohort = student.product_type === 'cohort';

  return (
    <Box>
      <Box padding={{ xs: 2, sm: 3 }} className={classes.header}>
        <Box display="flex" alignItems="center" marginBottom={2}>
          <IconButton
            color="primary"
            className={classes.backIcon}
            onClick={() => history.goBack()}
            edge="start"
          >
            <ArrowBackIcon color="inherit" />
          </IconButton>
          <Typography variant="h5">
            {student.user_first_name}'s Messages
          </Typography>
        </Box>
        <Box>
          <Box>
            <Tabs
              variant="scrollable"
              scrollButtons="auto"
              value={tab}
              indicatorColor="primary"
              textColor="primary"
              onChange={handleTabChange}
            >
              {student.product_type !== 'solo' &&
                student.product_type !== 'cohort' && [
                  <Tab
                    label={
                      <Box display="flex" alignItems="center">
                        <AvatarGroup spacing="small" style={{ marginLeft: 8 }}>
                          <Avatar src={student.lc?.user_pic}>
                            {getInitials(
                              student.lc?.user_first_name,
                              student.lc?.user_last_name,
                            )}
                          </Avatar>
                          <Avatar src={student.hc?.user_pic}>
                            {getInitials(
                              student.hc?.user_first_name,
                              student.hc?.user_last_name,
                            )}
                          </Avatar>
                        </AvatarGroup>
                        <Typography variant="body2" style={{ marginLeft: 8 }}>
                          Counseling Team
                        </Typography>
                      </Box>
                    }
                    {...a11yProps(0)}
                  />,
                  <Tab
                    label={
                      <Box display="flex" alignItems="center">
                        <AvatarGroup spacing="small" style={{ marginLeft: 8 }}>
                          <Avatar src={student.fa?.user_pic}>
                            {getInitials(
                              student.fa?.user_first_name,
                              student.fa?.user_last_name,
                            )}
                            {/* {getInitials(
                            student.fa?.user_first_name,
                            student.fa?.user_last_name,
                          )} */}
                          </Avatar>
                        </AvatarGroup>
                        <Typography variant="body2" style={{ marginLeft: 8 }}>
                          Financial Aid Counselor
                        </Typography>
                      </Box>
                    }
                    {...a11yProps(1)}
                  />,
                ]}
              <Tab
                label={
                  <Box display="flex" alignItems="center">
                    <Avatar src={student.admin?.user_pic}>
                      {getInitials(
                        student.admin?.user_first_name,
                        student.admin?.user_last_name,
                      )}
                    </Avatar>
                    <Typography variant="body2" style={{ marginLeft: 8 }}>
                      Program Supervisor
                    </Typography>
                  </Box>
                }
                {...a11yProps(2)}
              />
            </Tabs>
          </Box>
        </Box>
      </Box>
      <Box>
        {!rooms ? (
          <Spin spinning linear />
        ) : (
          <>
            {[coachRoom, faRoom, adminRoom]
              .filter((i) => (isSolo ? i.room_name !== 'parents_coaches' : i))
              .filter((i) => (isCohort ? i.room_name !== 'parents_coaches' : i))
              .map((i, idx) => {
                return (
                  <TabPanel
                    className={classes.tabContent}
                    value={tab}
                    index={idx}
                    key={i.id}
                  >
                    <Room
                      user={user}
                      profile={student}
                      tab={idx}
                      room={i}
                      isFocused={idx === tab}
                    />
                  </TabPanel>
                );
              })}
          </>
        )}
      </Box>
    </Box>
  );
};

export default StudentChatRooms;
